import { render, staticRenderFns } from "./select-text.vue?vue&type=template&id=2b7aab34&scoped=true"
import script from "./select-text.vue?vue&type=script&lang=js"
export * from "./select-text.vue?vue&type=script&lang=js"
import style0 from "./select-text.vue?vue&type=style&index=0&id=2b7aab34&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7aab34",
  null
  
)

export default component.exports